module.exports = __webpack_public_path__ + "img/new_startup.62204568.svg";